import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import queries from '@nc-aftermarket/config/queryDefs';

export default function useUserInfo() {
  const { data } = useQuery(queries.UserContext);
  return useMemo(
    () => ({
      bidding: data?.self?.bidding?.items?.map(sale => sale.id),
      watching: data?.self?.watchedProducts?.map(product => product.name),
      status: data?.self?.status,
    }),
    [data],
  );
}
